export default {"src":"/_next/static/media/sport-icon.396fc7f9.svg","height":500,"width":500};